<style lang="less">
</style>
<template>
  <div class="list">
    <div class="breadcrumb">
      <Breadcrumb>
        <Breadcrumb-item href="#">学生管理</Breadcrumb-item>
        <Breadcrumb-item>{{ pageTitle }}</Breadcrumb-item>
      </Breadcrumb>
    </div>
    <Tabs v-if="isTodayNew" type="card" v-model="newTab" @on-click="onNewTabClick">
      <TabPane label="今日新生" name="today"></TabPane>
      <TabPane label="本月新生" name="month"></TabPane>
    </Tabs>
    <div class="search" @keyup.enter="search">
      <Form :label-width="100" :show-message="false" label-positon="right">
<!--        <Row :gutter="32">
          <Col span="6">
            <Form-item label="是否分配学导" prop="isStudyAdviser">
              <Select v-model.number="queryParam.isStudyAdviser" placeholder="全部"
                      clearable @on-change="search">
                <Option value="1">已分配学导</Option>
                <Option value="0">未分配学导</Option>
              </Select>
            </Form-item>
          </Col>


          <Col span="6">
            <Form-item label="学生状态" prop="status">
              <Select v-model.number="queryParam.status" placeholder="全部"
                      clearable @on-change="search">
                <Option value="1">正常</Option>
                <Option value="0">禁用</Option>
              </Select>
            </Form-item>
          </Col>


          <Col span="6">
            <Form-item label="排序规则">
              <Select v-model.number="queryParam.sortRule"
                      clearable @on-change="search">
                <Option value="ASC">由少到多</Option>
                <Option value="DESC">由多到少</Option>
              </Select>
            </Form-item>
          </Col>

          <Col span="6">
            <Form-item label="课程标题">
              <Select v-model="queryParam.lessonId" clearable @on-change="search">
                <Option v-for="item in lessonAll"
                        :value="item.id" :key="item.id">{{ item.title }}
                </Option>
              </Select>
            </Form-item>
          </Col>

          <Col span="6">
            <Form-item label="学生年龄">
              <Input name="age" v-model.number="queryParam.age"></Input>
            </Form-item>
          </Col>

          <Col :xs="12" :sm="12" :md="6">
            <Form-item label="课程等级">
              <Select v-model.number="queryParam.bookMaterialLevelId" clearable @on-change="changeLevel">
                <Option value="0">未分级</Option>
                <Option v-for="item in bookMaterialLevelList" :key="item.id" :value="item.id">{{ item.title }}</Option>
              </Select>
            </Form-item>
          </Col>

        </Row>-->

        <Row>
          <Col :xs="12" :sm="12" :md="6">
            <Form-item label="创建时间">
              <Row>

                <Date-picker v-model="dateRange" format="yyyy-MM-dd" :clearable="true" type="daterange"
                             placement="bottom-start" placeholder="选择日期" style="width: 100%"/>

<!--                <Date-picker type="datetime" format="yyyy-MM-dd HH:mm" placeholder="请选择日期"
                             @on-change="startTimeDateChange"></Date-picker>
                -
                <Date-picker type="datetime" format="yyyy-MM-dd HH:mm" placeholder="请选择日期"
                             @on-change="endTimeDateChange"></Date-picker>-->
              </Row>
            </Form-item>
          </Col>
          <Col :xs="12" :sm="12" :md="6">
            <Form-item label="课节数">
              <Select name="lessonNum" v-model="queryParam.lessonNum" clearable @on-change="search">
                <Option value="0">全部</Option>
                <Option value="1">前8节课学生</Option>
                <Option value="2">剩余10节课学生</Option>
              </Select>
            </Form-item>
          </Col>
          <Col :xs="12" :sm="12" :md="6">
            <Form-item label="剩余课节数">
              <Input name="lastLessonNum" v-model="queryParam.lastLessonNum"></Input>
            </Form-item>
          </Col>
          <Col :xs="12" :sm="12" :md="6">
            <Form-item label="绑定课节数">
              <Input name="bindLessonNum" v-model.number="queryParam.bindLessonNum"></Input>
            </Form-item>
          </Col>

        </Row>

        <Row>
          <Col :xs="12" :sm="12" :md="6">
            <Form-item label="上课时间">
              <Select name="lessonWeek" multiple v-model="lessonWeek" clearable @on-change="selectWeek">
                <Option v-for="item in $constant.weekSelect" :value="item.code" :key="item.code">{{ item.text }}
                </Option>
              </Select>
            </Form-item>
          </Col>
          <Col :xs="12" :sm="12" :md="6">
            <Form-item label="学导姓名">
              <admin-user-select :status="1" adminGroupCode="userStudyAdviser"
                                 v-model="queryParam.adminUserId"
                                 :disabled="isTodayNew && isStudyAdviser"></admin-user-select>
            </Form-item>
          </Col>

          <Col :xs="12" :sm="12" :md="6">
            <Form-item label="课程顾问" prop="studyAdviserName">
              <admin-user-select :status="1" adminGroupCode="adviser"
                                 v-model="queryParam.adviserId"></admin-user-select>
            </Form-item>
          </Col>
          <Col :xs="12" :sm="12" :md="6">
            <FormItem label="教材版本">
              <Select v-model="queryParam.materialVersionId" @on-change="loadLevelIds" placeholder="请选择" clearable>
                <Option v-for="item in $constant.materialVersions" :key="item.code" :value="item.code">{{ item.text }}
                </Option>
              </Select>
            </FormItem>
          </Col>


        </Row>

        <Row>
          <Col :xs="12" :sm="12" :md="6">
            <Form-item label="老师ID">
              <Input name="id" v-model="queryParam.tchId"></Input>
            </Form-item>
          </Col>
          <Col :xs="12" :sm="12" :md="6">
            <Form-item label="老师名字">
              <Input placeholder="模糊" name="mobile" v-model="queryParam.tchName"></Input>
            </Form-item>
          </Col>

          <Col :xs="12" :sm="12" :md="6">
            <Form-item label="绑定老师数">
              <Input name="nickname" v-model="queryParam.tchBoundNum"></Input>
            </Form-item>
          </Col>
          <Col :xs="12" :sm="12" :md="6">
            <Form-item label="是否绑定老师" prop="isTch">
              <Select v-model.number="queryParam.isTch" placeholder="全部"
                      clearable @on-change="search">
                <Option value="1">已绑定老师</Option>
                <Option value="0">未绑定老师</Option>
              </Select>
            </Form-item>
          </Col>
        </Row>

        <Row>
          <Col :xs="12" :sm="12" :md="6">
            <Form-item label="学生" :label-width="60">
              <Input placeholder="ID/手机号/姓名" name="searchKeyword"
                     v-model="queryParam.searchKeyword"></Input>
            </Form-item>
          </Col>

          <Col :xs="12" :sm="12" :md="6">
            <Form-item label="下周是否排课" prop="isNextWeekLessonOpened">
              <Select v-model.number="queryParam.isNextWeekLessonOpened" placeholder="全部"
                      clearable @on-change="search">
                <Option value="1">已排课</Option>
                <Option value="0">未排课</Option>
              </Select>
            </Form-item>
          </Col>
          <Col :xs="12" :sm="12" :md="6">
            <Form-item label="课程类型" prop="tchChannel">
              <Select v-model.number="queryParam.tchChannel" placeholder="全部" clearable
                      @on-change="search">
                <Option v-for="item in $constant.tchChannel"
                        :value="item.code" :key="item.code">{{ item.text }}</Option>
              </Select>
            </Form-item>
          </Col>
        </Row>


      </Form>


      <div class="button-container">
        <Button class="left-button" type="primary" :loading="searchLoading" :disable="searchLoading" icon="search"
                @click="search">搜索
        </Button>

        <div class="spacer"></div>

        <Row>

          <Button type="primary" @click="onAssignAdviser">分配课程顾问</Button>
          <Button type="primary" @click="onAssignStudyAdviser">分配学导</Button>
          <!-- <Button type="primary" :loading="cancelLoading" :disable="cancelLoading" icon=""
                @click="batchCancel">移至结课
          </Button> -->
          <Button type="primary" :loading="stopLoading" :disable="stopLoading" icon=""
                  @click="showStopLessonModel">移至停课
          </Button>
          <Button type="primary" @click="showToRefundModal">移至退费
          </Button>
          <Button type="primary" :loading="stopLoading" :disable="stopLoading" icon=""
                  @click="cannelStudy">取消学导绑定
          </Button>
          <Button v-if="isTodayNew" type="primary" :loading="exportLoading" :disable="exportLoading" icon="search"
                  @click="exportData">导出
          </Button>
          <Button v-else type="primary" :loading="exportLoading" :disable="exportLoading" icon="search" v-perm="'309'"
                  @click="exportData">导出
          </Button>

        </Row>

      </div>
    </div>
    <List ref="dataList" :tableColumns="tableColumns" :reload="reload" listUrl="/user/pay/list" class="pay-list"
          :params="queryParam" :onLoading="onLoading" operator="" @on-selection-change="selectionChange"
          @on-sort-change="handleAssignTimeSortChange"></List>

    <AssignAdviserModal :successCallback="search" :userList="selectionUser"
                        v-model="showAssignAdviserModal"></AssignAdviserModal>
    <AssignUserStudyAdviserModal :successCallback="search" :userList="selectionUser"
                                 v-model="showAssignUserStudyAdviserModal"
                                 @on-close="onStudyAdviserClose"></AssignUserStudyAdviserModal>
    <UserTestNetworkModal :user="testNetworkParam" v-model="showTestNetworkModal">
    </UserTestNetworkModal>
    <UserLeaveModal v-model="showUserLeaveModal" :uid="uid" @on-close="closeModal"
                    :successCallback="search"></UserLeaveModal>
    <UserTempLessonModal :user="tempLessonUser" v-model="showUserTempLessonModal"></UserTempLessonModal>
    <UserPLLessonModal :user="pLLessonUser" v-model="showUserPLLessonModal"></UserPLLessonModal>
    <UserChineseLessonModal :user="chineseLessonUser" v-model="showUserChineseLessonModal"></UserChineseLessonModal>

    <UserClassHourModal :uid="uid" v-model="showUserClassHourModal"></UserClassHourModal>
    <UserLeaveNumModal :uid="uid" v-model="showUserLeaveNumModal"></UserLeaveNumModal>
    <UserLessonNumModal :uid="uid" v-model="showUserLessonNumModal"></UserLessonNumModal>
    <CourseSchedulingModal :uid="uid" v-model="showCourseSchedulingModal"
                           @on-close="closeModal"></CourseSchedulingModal>
    <BindTchModal :user="currentRow" :successCallback="search" v-model="showBindTchModal"></BindTchModal>
    <UserInfoModal :value="editUser" @on-close="closeModal" :uid="uid" :successCallback="search"></UserInfoModal>
    <UserActivityNumModal :uid="uid" v-model="showActivityNumModal" :successCallback="search"></UserActivityNumModal>

    <BookExchangeModal :uid="uid" v-model="showBookExchangeModal"/>
    <StudentClassHourModal :uid="uid" v-model="showStudentClassHourModal"></StudentClassHourModal>
    <ToRefundModal v-model="showRefundModal" :uid="refundUid" :successCallback="search"></ToRefundModal>
    <Modal title="请填写停课理由" v-model="showStudentLeaveModal">
      <Form class="form" ref="showStudentLeave" :model="showStudentLeaveForm" :rules="showStudentLeaveRule">
        <Row>
          <Col :span="20">
            <Form-item label="复课时间" prop='startStudyDate'>
              <DatePicker type="date" :options="options" placeholder="选择时间" style="width: 200px"
                          @on-change="startStudyDate"></DatePicker>
            </Form-item>
          </Col>
        </Row>
        <Row>
          <Col :span="20">
            <Form-item label="停课原因" prop='leaveResult'>
              <Input v-model="showStudentLeaveForm.leaveResult" type="textarea" :autosize="{minRows: 2,maxRows: 5}"
                     placeholder="请输入停课理由"/>
            </Form-item>
          </Col>
        </Row>
      </Form>
      <div slot="footer">
        <Button type="text" size="large" @click="showStudentLeaveModal = false">取消</Button>
        <Button type="primary" size="large" :loading="loadingShowStudentLeave" @click="inStopLesson">确定</Button>
      </div>
    </Modal>
    <AiDrawer
      :visible.sync="aiVisible"
      :uid="aiUid"
      :page-route="pageRoute"
      default-task-type="ADVISOR_AFTER_CLASS"
      @on-executed="onAiExecuted"
      @on-close="onAiClose"
    />
  </div>
</template>
<style scoped>
.pay-list .ivu-table-cell {
  padding-left: 8px;
  padding-right: 8px;
}

.btn-wrap {
  text-align: end;
  margin-top: 24px;
}

.button-container {
  margin-bottom: 15px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.left-button {
  align-self: flex-start;
}

.right-button {
  align-self: flex-end;
}

.spacer {
  flex: 1;
}
</style>
<script>
import AssignAdviserModal from './AssignAdviserModal.vue'
import AssignUserStudyAdviserModal from './modal/AssignUserStudyAdviserModal.vue'
import UserTestNetworkModal from './modal/UserTestNetworkModal.vue'
import UserLeaveModal from './UserLeaveModal.vue'
import UserTempLessonModal from './modal/UserTempLessonModal.vue'
import UserPLLessonModal from './UserPLLessonModal.vue'
import UserChineseLessonModal from './UserChineseLessonModal.vue'
import UserClassHourModal from './UserClassHourModal.vue'
import UserLeaveNumModal from './UserLeaveNumModal.vue'
import UserLessonNumModal from './UserLessonNumModal.vue'
import CourseSchedulingModal from './modal/CourseSchedulingModal.vue'
import UserInfoModal from '../crm/UserInfoModal.vue'
import BindTchModal from './modal/BindTchModal.vue'
import UserActivityNumModal from './UserActivityNumModal.vue'
import dates from '@/tools/date/dates.js'
import BookExchangeModal from './BookExchangeModal.vue'
import StudentClassHourModal from './modal/StudentClassHourModal.vue'
import ToRefundModal from './modal/ToRefundModal.vue'
import OrderClassHourModal from '../order/OrderClassHourModal.vue'
import AiDrawer from '@/components/ai/AiDrawer'
import { bindAiAllowed } from '@/tools/aiAccess'
export default {
  components: {
    OrderClassHourModal,
    BookExchangeModal,
    AssignAdviserModal,
    AssignUserStudyAdviserModal,
    UserTestNetworkModal,
    UserLeaveModal,
    UserTempLessonModal,
    UserPLLessonModal,
    UserChineseLessonModal,
    UserClassHourModal,
    UserLeaveNumModal,
    CourseSchedulingModal,
    BindTchModal,
    UserInfoModal,
    UserLessonNumModal,
    UserActivityNumModal,
    StudentClassHourModal,
    ToRefundModal,
    AiDrawer
  },
  data() {
    let $constant = this.$constant
    let $moment = this.$moment
    return {
      searchLoading: false,
      exportLoading: false,
      cancelLoading: false,
      stopLoading: false,
      reload: 0,
      aiVisible: false,
      aiUid: null,
      aiAllowed: false,
      isSalesGroup10: false,
      editUser: false,
      showStudentLeaveModal: false,
      loadingShowStudentLeave: false,
      ids: '',
      options: {
        disabledDate(date) {
          return date && date.valueOf() < Date.now() - 86400000;
        }
      },
      showStudentLeaveForm: {
        startStudyDate: '',
        leaveResult: ''
      },
      showStudentLeaveRule: {
        startStudyDate: [
          {type: 'string', required: true, message: '请选择时间', trigger: 'blur'}
        ],
        leaveResult: [
          {type: 'string', required: true, message: '请输入停课原因', trigger: 'blur'}
        ]
      },
      dateRange: [],
      newTab: 'today',
      isStudyAdviser: Number(this.$store.get('adminRule')) === 2,
      queryParam: {
        startTime: '',
        adviserId: '',
        adminUserId: '',
        endTime: '',
        isStudyAdviser: '',
        isTch: '',
        tchBoundNum: null,
        tchChannel: '',
        isNextWeekLessonOpened: '',
        status: null,
        searchKeyword: '',
        studyAdviserName: '',
        studyAdviserMobile: '',
        materialVersionId: '',
        bookMaterialLevelId: '',
        bindLessonNum: '',
        age: null,
        lessonWeek: '',
        lessonId: '',
        lessonNum: '',
        lastLessonNum: ''
      },
      lessonWeek: [],
      uid: null,
      currentRow: null,
      showAssignAdviserModal: false,
      showAssignUserStudyAdviserModal: false,
      selectionUser: [],
      showTestNetworkModal: false,
      showUserLeaveModal: false,
      tempLessonUser: {},
      showUserTempLessonModal: false,
      pLLessonUser: {},
      showUserPLLessonModal: false,
      chineseLessonUser: {},
      showUserChineseLessonModal: false,
      showUserClassHourModal: false,
      showUserLeaveNumModal: false,
      showUserLessonNumModal: false,
      showCourseSchedulingModal: false,
      showActivityNumModal: false,
      showBookExchangeModal: false,
      showBindTchModal: false,
      showStudentClassHourModal: false,
      showRefundModal: false,
      refundUid: '',
      testNetworkParam: {},
      title: [
        {
          type: 'selection',
          width: 40,
          fixed: 'left',
          align: 'center'
        },
        {
          title: 'ID',
          key: 'id',
          align: 'center',
          fixed: 'left',
          width: 84
        },
        {
          title: '中(英)文名',
          width: 90,
          fixed: 'left',
          align: 'center',
          render: (h, params) => {
            let row = params.row
            let age = row.age
            if (age) {
              age = age + '岁'
            }
            const textStyle = row.stdLeaveRule === 2 ? { fontWeight: 'bold', fontSize: '15px' } : {}
            return h('div', [
              h('a', {on: {click: () => this.openInfoModal(row.id)}, style: textStyle}, row.nickname),
              h('p', {style: textStyle}, row.enName),
              h('p', {style: textStyle}, age)
            ])
          }
        },
        {
          title: '手机号',
          align: 'center',
          width: 85,
          key: 'mobile',
          render: (h, params) => {
            return h('Poptip', {
              props: {
                trigger: 'hover'
              }
            }, [
              h('span', {on: {click: () => this.openInfoModal(row.id)}},
                params.row.mobile.length === 11 ? params.row.mobile.substring(0, 3)
                  + "****" + params.row.mobile.substring(7) : params.row.mobile),
              // 当前行展示的数据
              h('div', {slot: 'content'}, params.row.mobile)
            ])
          }
        },
        {
          title: '等级',
          //width: 130,
          align: 'center',
          render: (h, params) => {
            return h('span', params.row.levelTitle || '未分级')
          }
        },
        {
          title: '绑定老师',
          width: 220,
          align: 'center',
          render: (h, params) => {
            let row = params.row
            let tchBoundNum = row.tchBoundNum
            if (tchBoundNum && tchBoundNum > 0) {
              let list = row.bookWorkLessonOpenedTimeList
              let spanArr = []
              if (list) {
                list.forEach(function (element) {
                  let startTime = $moment.unix(element.startTime).utc().format(' HH:mm')
                  spanArr.push(h('span', [h('span', {style: {color: '#2d8cf0'}}, element.tchId + '-' + element.tchName),
                    h('span', '[' + $constant.weekZh[element.week] + startTime + ']')]))
                  spanArr.push(h('br'))
                })
              }
              let levelTitle = row.levelTitle
              if (levelTitle) {
                levelTitle = '当前等级：' + levelTitle
              }
              return h('div', {style: {'font-size': '12px'}}, [h('p', levelTitle), h('p', spanArr)])
            } else {
              return h('div', '未绑定')
            }
          }
        },
        {
          title: '订单列表',
          align: 'center',
          width: 310,
          render: (h, params) => {
            let row = params.row
            let list = row.fundPackageDtoList
            let spanArr = []
            if (list) {
              list.forEach(function (e) {
                let state = e.state
                let stateStr = ''
                if (state) {
                  if (state === 4) {
                    stateStr = '部分支付'
                  } else if (state === 5) {
                    stateStr = '全部支付'
                  } else if (state === 1) {
                    stateStr = '支付成功'
                  } else if (state === 6) {
                    stateStr = '财务审核'
                  }
                } else {
                  if (state === 0) {
                    stateStr = '待支付'
                  }
                }
                let channel = ''
                if (e.channel) {
                  let channelEnum = $constant.getEnum($constant.orderChannel, e.channel)
                  channel = channelEnum && channelEnum.text
                }
                if (row.tchChannel === 1) {
                  spanArr.push(h('span', [
                    h('span', {style: {color: '#2d8cf0'}}, e.orderId + ':'),
                    h('span', channel + '外教课' + e.num + '节/直播课' + e.livingNum + '/中教课' + e.chineseNum + '节(' + e.amount + '元)->'),
                    h('span', {style: {color: 'red'}}, stateStr)]))
                }
                if (row.tchChannel === 2) {
                  spanArr.push(h('span', [
                    h('span', {style: {color: '#2d8cf0'}}, e.orderId + ':'),
                    h('span', '(' + e.amount + '元)->'),
                    h('span', {style: {color: 'red'}}, stateStr)]))
                }
                spanArr.push(h('br'))
              })
            }
            return h('div', {style: {'font-size': '13px'}}, spanArr)
          }
        },
        {
          title: '课时信息',
          align: 'center',
          width: 160,
          render: (h, params) => {
            let row = params.row
            if (row.tchChannel === 2) {
              return h('a', {on: {click: () => this.showStudentClassHour(row)}}, '可用课时：' + row.availableClassHour)
            }
            let leftRoutineNum = row.routineNum - row.routineEndNum
            leftRoutineNum = leftRoutineNum > 0 ? leftRoutineNum : 0
            let leftChineseNum = row.chineseNum - row.chineseEndNum
            leftChineseNum = leftChineseNum > 0 ? leftChineseNum : 0
            let leftPartNum = row.partnerNum - row.partnerEndNum
            leftPartNum = leftPartNum > 0 ? leftPartNum : 0
            return h('div', {style: {'font-size': '13px'}}, [h('p', '外教/中教/陪练课'),
              h('p', '总课时:' + row.routineNum + ' / ' + row.chineseNum + ' / ' + row.partnerNum),
              h('p', '已完结:' + row.routineEndNum + ' / ' + row.chineseEndNum + ' / ' + row.partnerEndNum),
              h('p', {style: {color: 'red'}}, '剩余:' + leftRoutineNum + ' / ' + leftChineseNum + ' / ' + leftPartNum),
              h('p', {style: {color: 'green'}}, '锁定:' + row.waitEngNum + ' / ' + row.waitChineseNum + ' / ' + row.waitPartnerNum)
            ])
          }
        },
        /*       {
                 title: '请假统计',
                 width: 100,
                 align: 'center',
                 render: (h, params) => {
                   let row = params.row
                   let leaveNum = row.leaveNum
                   leaveNum = leaveNum > 0 ? leaveNum : 0
                   let leftMakeUpLessonNum = row.makeupLessonNum - row.makeupLessonEndNum
                   leftMakeUpLessonNum = leftMakeUpLessonNum > 0 ? leftMakeUpLessonNum : 0
                   return h('div', [h('p', '请假次数:' + leaveNum), h('p', '补课次数:' + leftMakeUpLessonNum)])
                 }
               }, */
        {
          title: '课程顾问',
          width: 90,
          align: 'center',
          key: 'adviserName',
          render: (h, params) => {
            return h('span', params.row.adviserName || '未分配')
          }
        },
        {
          title: '学导',
          width: 90,
          align: 'center',
          key: 'studyAdviserName',
          render: (h, params) => {
            return h('span', params.row.studyAdviserName || '未分配')
          }
        },
        {
          title: '操作',
          align: 'center',
          fixed: 'right',
          width: 70,
          render: (h, params) => {
            let row = params.row
            let id = row.id
            // let userTrackListQueryParam = {
            //   uid: id
            // }
            let btn = []
            if (this.aiAllowed) {
              btn.push(h('Dropdown-item', {props: {name: 'ai'}}, 'AI'))
            }
            btn.push(h('Dropdown-item', {props: {name: 'testNetwork'}}, '约测网课'))
            btn.push(h('Dropdown-item', {props: {name: 'courseScheduling'}}, '固定排课'))
            btn.push(h('Dropdown-item', {props: {name: 'userTemp'}}, '临时约课'))

            btn.push(h('Dropdown-item', {props: {name: 'PracticePartnerLesson'}}, '约陪练课'))
            btn.push(h('Dropdown-item', {props: {name: 'chineseLesson'}}, '约中教课'))
            btn.push(h('Dropdown-item', {props: {name: 'userLeave'}}, '学生请假'))
            let bookWorkLessonOpenedTimeList = row.bookWorkLessonOpenedTimeList
            if (!bookWorkLessonOpenedTimeList) {
              btn.push(h('Dropdown-item', {props: {name: 'bindTch'}}, '绑定老师'))
            } else if (!this.isSalesGroup10) {
              btn.push(h('Dropdown-item', {props: {name: 'editBindTch'}}, '修改绑定'))
            }
            btn.push(h('Dropdown-item', {props: {name: 'changeDirector'}}, '学员转移'))
            btn.push(h('Dropdown-item', {props: {name: 'classHour'}}, '加减课时'))
            btn.push(h('Dropdown-item', {props: {name: 'leaveNum'}}, '加减请假次数'))
            btn.push(h('Dropdown-item', {props: {name: 'lessonNum'}}, '加减补课次数'))
            btn.push(h('Dropdown-item', {props: {name: 'track'}}, '跟踪记录'))
            btn.push(h('Dropdown-item', {props: {name: 'activity'}}, '积分兑换'))
            btn.push(h('Dropdown-item', {props: {name: 'book'}}, '绘本兑换'))
            return h('div', [
              h('Dropdown', {
                props: {
                  transfer: true,
                  trigger: 'click',
                },
                on: {
                  'on-click': (name) => {
                    if (name === 'ai') {
                      this.aiUid = row.id
                      this.aiVisible = true
                    } else if (name === 'testNetwork') {
                      this.showTestNetworkModal = true
                      this.testNetworkParam = row
                      this.testNetworkParam.uid = row.id
                    } else if (name === 'userTemp') {
                      this.showUserTempLessonModal = true
                      this.tempLessonUser = row
                    } else if (name === 'userLeave') {
                      this.uid = id
                      this.showUserLeaveModal = true
                    } else if (name === 'PracticePartnerLesson') {
                      this.pLLessonUser = row
                      this.showUserPLLessonModal = true
                    } else if (name === 'chineseLesson') {
                      this.chineseLessonUser = row
                      this.showUserChineseLessonModal = true
                    } else if (name === 'bindTch') {
                      this.currentRow = row
                      this.showBindTchModal = true
                    } else if (name === 'editBindTch') {
                      this.currentRow = row
                      this.showBindTchModal = true
                    } else if (name === 'unbindTch') {
                      this.onUnbingTch(row)
                    } else if (name === 'classHour') {
                      this.uid = id
                      this.showUserClassHourModal = true
                    } else if (name === 'changeDirector') {
                      this.uid = id
                      this.onChangeDirector(row)
                    } else if (name === 'leaveNum') {
                      this.uid = id
                      this.showUserLeaveNumModal = true
                    } else if (name === 'lessonNum') {
                      this.uid = id
                      this.showUserLessonNumModal = true
                    } else if (name === 'courseScheduling') {
                      this.uid = id
                      this.showCourseSchedulingModal = true
                    } else if (name === 'track') {
                      this.$router.push({path: '/user/userTrackList', query: this.userTrackListQueryParam})
                    } else if (name === 'activity') {
                      this.uid = id
                      this.showActivityNumModal = true
                    } else if (name === 'book') {
                      this.uid = id
                      this.showBookExchangeModal = true
                    }
                  }
                }
              }, [
                h('a', [
                  h('span', '更多 '),
                  h('Icon', {props: {type: 'ios-arrow-down'}})
                ]),
                h('Dropdown-menu', {slot: 'list'}, btn)
              ]),
            ])
          }
        }
      ],
      bookMaterialLevelList: [],
      lessonAll: []
    }
  },
  computed: {
    isTodayNew () {
      return this.$route.path === '/user/userTodayNewList'
    },
    pageTitle () {
      if (!this.isTodayNew) {
        return '常规学生列表'
      }
      return this.newTab === 'month' ? '本月新生' : '新生分配'
    },
    pageRoute () {
      return this.isTodayNew ? '/user/userTodayNewList' : '/user/userPayList'
    },
    tableColumns () {
      if (!this.isTodayNew) {
        return this.title
      }
      let cols = this.title.slice()
      let idx = cols.findIndex(function (col) {
        return col.key === 'studyAdviserName'
      })
      if (idx < 0) {
        return cols
      }
      let self = this
      cols.splice(idx + 1, 0, {
        title: '分配时间',
        width: 160,
        align: 'center',
        key: 'studyAdviserAssignTime',
        sortable: 'custom',
        sortType: self.queryParam.sortDirection === 'desc' ? 'desc' : 'asc',
        render: function (h, params) {
          let time = params.row.studyAdviserAssignTime
          if (!time) {
            return h('span', '-')
          }
          return h('span', self.$moment(time).format('YYYY-MM-DD HH:mm:ss'))
        }
      }, {
        title: '是否联系过',
        width: 120,
        align: 'center',
        key: 'studyAdviserContacted',
        render: function (h, params) {
          let row = params.row
          let contacted = row.studyAdviserContacted === 1 ? 1 : 0
          return h('Select', {
            style: {color: contacted === 1 ? 'green' : 'red'},
            props: {
              value: contacted,
              transfer: true
            },
            on: {
              'on-change': function (value) {
                self.updateTodayNewContacted(row, value)
              }
            }
          }, [
            h('Option', {props: {value: 0}, style: {color: 'red'}}, '未联系'),
            h('Option', {props: {value: 1}, style: {color: 'green'}}, '已联系')
          ])
        }
      })
      return cols
    }
  },
  watch: {
    '$route' (to, from) {
      if (!from || to.path === from.path) {
        return
      }
      this.applyTodayNewFlag()
      this.applyTodayNewStudyAdviser()
      this.reload = new Date().getTime()
    }
  },
  mounted: function () {
    let query = this.$route.query
    if (query) {
      if (query.lessonWeek) {
        let lessonWeekArr = query.lessonWeek.split(',')
        for (let i in lessonWeekArr) {
          this.lessonWeek[i] = parseInt(lessonWeekArr[i])
        }
      }
    }
  },
  created: function () {
    bindAiAllowed(this)
    this.loadSalesGroupFlag()
    this.applyTodayNewFlag()
    this.applyTodayNewStudyAdviser()
    let query = this.$route.query
    if (query) {
      if (query.lessonWeek) {
        let lessonWeekArr = query.lessonWeek.split(',')
        for (let i in lessonWeekArr) {
          this.lessonWeek[i] = parseInt(lessonWeekArr[i])
        }
      }
    }
  },
  methods: {
    loadSalesGroupFlag () {
      let self = this
      let id = this.$store.get('id')
      if (!id) {
        return
      }
      this.$http.get('/adminUser/queryById', {params: {id: id}}).then(function (res) {
        if (res && res.data) {
          self.isSalesGroup10 = Number(res.data.groupId) === 10
        }
      })
    },
    applyTodayNewStudyAdviser () {
      if (this.isTodayNew && this.isStudyAdviser) {
        this.queryParam.adminUserId = parseInt(this.$store.get('id'))
      }
    },
    applyTodayNewFlag () {
      if (!this.isTodayNew) {
        this.$delete(this.queryParam, 'queryTodayNew')
        this.$delete(this.queryParam, 'queryMonthNew')
        this.$delete(this.queryParam, 'sortProperty')
        this.$delete(this.queryParam, 'sortDirection')
        return
      }
      if (this.newTab === 'month') {
        this.$set(this.queryParam, 'queryMonthNew', true)
        this.$delete(this.queryParam, 'queryTodayNew')
      } else {
        this.$set(this.queryParam, 'queryTodayNew', true)
        this.$delete(this.queryParam, 'queryMonthNew')
      }
      if (!this.queryParam.sortProperty) {
        this.$set(this.queryParam, 'sortProperty', 'studyAdviserAssignTime')
      }
      if (!this.queryParam.sortDirection) {
        this.$set(this.queryParam, 'sortDirection', 'asc')
      }
    },
    onNewTabClick (name) {
      this.newTab = name
      this.applyTodayNewFlag()
      this.search()
    },
    handleAssignTimeSortChange (column, key, order) {
      if (!this.isTodayNew || key !== 'studyAdviserAssignTime') {
        return
      }
      if (order && order !== 'normal') {
        this.$set(this.queryParam, 'sortProperty', 'studyAdviserAssignTime')
        this.$set(this.queryParam, 'sortDirection', order)
      } else {
        this.$set(this.queryParam, 'sortProperty', 'studyAdviserAssignTime')
        this.$set(this.queryParam, 'sortDirection', 'asc')
      }
      this.reload = new Date().getTime()
    },
    updateTodayNewContacted (row, value) {
      let contacted = value === 1 ? 1 : 0
      this.$http.post('/user/pay/today-new-contact', {uid: row.id, contacted: contacted}).then((res) => {
        if (res.status === 'ok') {
          row.studyAdviserContacted = contacted
        } else {
          this.$Message.error(res.msg || '保存失败')
        }
      })
    },
    startTimeDateChange(value) {
      this.queryParam.startTime = value && this.$moment(value, 'YYYY-M-D H:m').format('X')
    },
    endTimeDateChange(value) {
      this.queryParam.endTime = value && this.$moment(value, 'YYYY-M-D H:m').format('X')
    },
    openInfoModal(val) {
      this.uid = val
      let {href} = this.$router.resolve({
        name: 'userPayDetail',
        query: {uid: val, tabName: 0, parm: self.queryParam, backPath: this.pageRoute}
      })
      window.open(href, '_blank')
    },

    onStudyAdviserClose () {
      this.showAssignUserStudyAdviserModal = false
    },
    onAiClose () {
      this.aiVisible = false
      this.aiUid = null
    },
    onAiExecuted () {
      this.reload = new Date().getTime()
    },
    search () {
      let self = this
      if (this.dateRange.length === 2) {
        if (this.dateRange[0]) {
          let startTimeDate = dates.format(this.dateRange[0])
          self.queryParam.startTime = Date.parse(startTimeDate) / 1000
        } else {
          self.queryParam.startTime = ''
        }
        if (this.dateRange[1]) {
          self.queryParam.endTime = this.$moment(this.dateRange[1], 'YYYY-M-D H:m').format('X')
        } else {
          self.queryParam.endTime = ''
        }
      } else {
        self.queryParam.startTime = ''
        self.queryParam.endTime = ''
      }

      this.selectionUser = []
      this.reload = new Date().getTime()
    },
    searchList() {
      this.reload = new Date().getTime()
    },
    onLoading(loading) {
      this.searchLoading = loading
    },
    selectionChange(selection) {
      this.selectionUser = selection
    },
    exportData () {
      this.applyTodayNewFlag()
      this.exportLoading = true
      this.$http.get('/user/pay/export', {responseType: 'arraybuffer', params: this.queryParam}).then((response) => {
        if (response.data) {
          let blob = new Blob([response.data], {type: 'text/csv'})
          let link = document.createElement('a')
          link.target = '_blank'
          link.href = window.URL.createObjectURL(blob)
          let downloadName = '付费学生.xls'
          if (this.isTodayNew) {
            downloadName = this.newTab === 'month' ? '本月新生.xls' : '今日新生.xls'
          }
          link.download = downloadName
          link.click()
          this.exportLoading = false
        } else {
          this.$Message.error(response.msg)
        }
      }).catch((e) => {
        this.exportLoading = false
      })
    },
    onAssignAdviser() {
      if (this.selectionUser.length <= 0) {
        this.$Message.warning('请选择需分配课程顾问的学生！')
        return
      }
      this.showAssignAdviserModal = true
    },
    batchCancel() {
      this.cancelLoading = true
      let ids = []
      if (this.selectionUser && this.selectionUser.length > 0) {
        for (let i in this.selectionUser) {
          let dto = this.selectionUser[i]
          ids[i] = dto.id
        }
      }
      let self = this
      this.$http.post('/user/lessonsStop/inUserOverLesson', {ids: ids.join(',')}).then((res) => {
        if (res && res.data > 0) {
          self.$Message.success('移至结课成功！')
          self.cancelLoading = false
          self.search()
        } else {
          self.$Message.error(res.msg)
          self.cancelLoading = false
        }
      }).catch((e) => {
        self.$Message.error(e)
        this.cancelLoading = false
      })
    },

    startStudyDate(value) {
      console.log(`value`, value)
      if (value === '') {
        this.$Message.warning('请输入复课时间')
      }
      this.showStudentLeaveForm.startStudyDate = value && this.$moment(value, 'YYYY-M-D H:m').format('X')
    },
    showStopLessonModel() {
      let self = this
      let ids = []
      if (this.selectionUser && this.selectionUser.length > 0) {
        for (let i in this.selectionUser) {
          let dto = this.selectionUser[i]
          ids[i] = dto.id
        }
      } else {
        this.$Message.warning('请选择停课目标')
        return
      }
      self.ids = ids.join(',')
      self.showStudentLeaveModal = true
    },
    showToRefundModal () {
      if (!this.selectionUser || this.selectionUser.length !== 1) {
        this.$Message.warning('请勾选恰好1名学生')
        return
      }
      this.refundUid = this.selectionUser[0].id
      this.showRefundModal = true
    },
    // 已试听
    inStopLesson() {
      let self = this
      this.stopLoading = true
      if (self.showStudentLeaveForm.startStudyDate == '' || self.showStudentLeaveForm.leaveResult == '') {
        this.$Message.warning('请填写停课信息')
        return
      }
      this.$http.post('/user/lessonsStop/inUserStopLesson', {
        ids: self.ids,
        resumeClassDate: this.showStudentLeaveForm.startStudyDate,
        remark: this.showStudentLeaveForm.leaveResult
      }).then((res) => {
        if (res && res.data > 0) {
          self.$Message.success('移至停课，申请审核成功！')
          self.stopLoading = false
          self.showStudentLeaveModal = false
          self.search()
        } else {
          self.$Message.error(res.msg)
          self.stopLoading = false
          self.showStudentLeaveModal = false

        }
      }).catch((e) => {
        this.stopLoading = false
        self.$Message.error(e)
      })
    },

    onAssignStudyAdviser() {
      if (this.selectionUser.length <= 0) {
        this.$Message.warning('请选择需分配学习顾问的学生！')
        return
      }
      this.showAssignUserStudyAdviserModal = true
    },

    onChangeDirector(row) {
      let self = this
      self.$Modal.confirm({
        title: '提示',
        content: '是否确认转移学员至学导部门经理？',
        width: 300,
        loading: true,
        onOk: () => {
          self.$http.post('/userTrack/changeDirectorRecord', {
            uid: row.id,
            nickname: row.nickname
          }).then(function (res) {
            self.search()
            self.$Message.success('转移成功!')
            self.$Modal.remove()
          })
        }
      })
    },
    selectWeek() {
      this.queryParam.lessonWeek = []
      this.queryParam.lessonWeek = this.lessonWeek.join(',')
    },
    loadLevelIds(val) {
      let self = this
      let url = '/bookMaterialLevel/listByCondition'
      if (val) {
        url = '/bookMaterialLevel/listByCondition?materialVersion=' + val
      }
      self.$http.get(url).then(res => {
        if (res && res.data) {
          self.bookMaterialLevelList = res.data
        }
      })
    },
    changeLevel(val) {
      let self = this
      if (val) {
        self.$http.get('/bookMaterialLessons/listByCondition?levelId=' + val).then(function (res) {
          if (res && res.data) {
            self.lessonAll = res.data
          }
        })
      }
    },
    cannelStudy() {
      let self = this
      let idList = self.selectionUser.map(function (element) {
        return element.id
      })
      self.loadingAssignAdviser = true
      let params = {ids: idList.join(','), studyAdviserId: 0, reason: ''}
      self.$http.get('/user/updateStudyAdviser', {params: params}).then(function (res) {
        if (res) {
          self.$Message.success('成功！')
          self.loadingAssignAdviser = false
          self.search()
        }
      }).catch(function (e) {
        self.$Message.error('失败！')
        self.loadingAssignAdviser = false
      })
    },
    showStudentClassHour (row) {
      this.uid = row.id
      this.showStudentClassHourModal = true
    }
  }
}

</script>



// WEBPACK FOOTER //
// UserPayList.vue?2b52c8b8